module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav-link"
  }, [_c('el-link', {
    attrs: {
      "href": "/#/dealer/login",
      "icon": "el-icon-s-marketing"
    }
  }, [_vm._v("商家登录")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "href": "/#/shop/login",
      "icon": "el-icon-s-shop"
    }
  }, [_vm._v("门店登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [(_vm.bannerVisible) ? _c('div', {
    staticStyle: {
      "background": "#f8f8f8"
    }
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "height": "200px"
    }
  }, _vm._l((_vm.bannerList), function(item) {
    return _c('el-carousel-item', {
      key: item.id
    }, [_c('a', {
      staticClass: "banner-item",
      style: (("background-image:url(" + (item.imgUrl) + ");")),
      attrs: {
        "href": item.linkUrl
      }
    })])
  }), 1)], 1) : _vm._e()]), _vm._v(" "), (!_vm.logined) ? _c('el-form', {
    ref: "formData",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("员工登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": "",
      "size": "small"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event)
      }
    }
  }, [_vm._v("登录")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n     \n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a360235a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/staff/Login.vue
// module id = 1190
// module chunks = 2